import React from 'react';
import PropTypes from 'prop-types';

import { Tooltip } from '@metarouter-private/mr-mui';

const TOOLTIP_PROPS = {
  arrow: true,
  placement: 'top',
};

const MAX_Z_INDEX_PROPS = {
  PopperProps: {
    sx: {
      zIndex: 3000,
    },
  },
};

export default function WithTooltip({
  children,
  show,
  title,
  dataTestId = 'tooltip',
  noContainer,
  Container = 'span',
  ContainerProps = {},
  maxZIndex = false,
}) {
  const wrapChildren = () => {
    /**
     * - Why? -
     *  Tooltip needs to target a ref on its immediate child in order to function
     *  As a result, any components not forwarding a ref will fail to render the Tooltip
     *  In some cases, however, a component will need to maintain its tree uninterupted to function correctly
     */
    if (noContainer) {
      return children;
    }

    return <Container {...ContainerProps}>{children}</Container>;
  };

  if (show) {
    const tooltipProps = {
      ...TOOLTIP_PROPS,
      ...(maxZIndex ? MAX_Z_INDEX_PROPS : {}),
    };

    return (
      <Tooltip {...tooltipProps} title={title} data-test-id={dataTestId}>
        {wrapChildren()}
      </Tooltip>
    );
  }

  return children;
}

WithTooltip.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.node,
  show: PropTypes.bool,
  dataTestId: PropTypes.string,
  noContainer: PropTypes.bool,
  Container: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  ContainerProps: PropTypes.object,
  maxZIndex: PropTypes.bool,
};
